import classNames from 'classnames/bind';
import Error from 'common/error';
import { LargeView, SmallView } from 'common/layout';
import Loading from 'common/loading';
import { useDeleteHistory, useSearchHistories } from 'hooks/useHistory';
import styles from './index.module.scss';
import Mobile from './list/Mobile';
import PC from './list/PC';

const cx = classNames.bind(styles);

interface IProps {
  count: number;
}

function History({ count }: IProps) {
  const deleteHistory = useDeleteHistory(count);
  const { loading, error, data } = useSearchHistories(count);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  if (!data?.searchHistories.length) return null;

  const { searchHistories } = data;

  return (
    <div className={cx('History')}>
      <div className={cx('inner')}>
        <h3 className={cx('title')}>최근 검색한 여행지</h3>
        <SmallView>
          <Mobile
            searchHistories={searchHistories}
            count={count}
            deleteHistoryFunc={deleteHistory}
          />
        </SmallView>
        <LargeView>
          <PC
            searchHistories={searchHistories}
            deleteHistoryFunc={deleteHistory}
          />
        </LargeView>
      </div>
    </div>
  );
}

export default History;
